import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  makeStyles,
} from '@material-ui/core';
import { Button } from '@saviynt/design-system';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  content: {
    padding: '1rem 0',
  },
});

function PasswordPolicyForm({ isOpen, onClose, title, data, onConfirm }) {
  const classes = useStyles();
  const [policyName, setPolicyName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (data) {
      try {
        const policyData = typeof data === 'string' ? JSON.parse(data) : data;
        setPolicyName(policyData.policyname || '');
        setDescription(policyData.description || '');
      } catch (error) {
        setPolicyName('');
        setDescription('');
      }
    }
  }, [data]);

  const handleConfirm = () => {
    const updatedConfig = {
      ...data,
      policyname: policyName,
      description,
    };
    onConfirm(updatedConfig);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Password Policy Configuration - {title}</DialogTitle>
      <DialogContent>
        <div className={classes.content}>
          <TextField
            label="Policy Name"
            value={policyName}
            onChange={(e) => setPolicyName(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
          />
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
            multiline
            rows={3}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm}>
          Save Configuration
        </Button>
      </DialogActions>
    </Dialog>
  );
}

PasswordPolicyForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onConfirm: PropTypes.func.isRequired,
};

PasswordPolicyForm.defaultProps = {
  data: null,
};

export default PasswordPolicyForm;
